import React from 'react';
import Modal from 'react-modal';
import ButtonFilled from '../FormElements/ButtonFilled';
import styles from './feature_disabled_modal.module.scss';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 0,
    borderRadius: 24,
    maxWidth: '400px',
    width: '90%',
  }
};

const FeatureDisabledModal = ({ isOpen, onClose }) => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '77757000030';
    const message = encodeURIComponent('Здравствуйте! Я хотел бы подключить дополнительные функции в системе Sagi.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      style={modalStyles}
      onRequestClose={onClose}
    >
      <div className={styles.modal}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h3 className={styles.title}>Функция недоступна</h3>
          </div>

          <div className={styles.content}>
            <p className={styles.message}>
              Данная функция вам недоступна, для подключения обращайтесь в тех поддержку Sagi
            </p>
          </div>

          <div className={styles.actions}>
            <ButtonFilled
              onClick={handleWhatsAppClick}
              className={styles.whatsappButton}
            >
              Написать на WhatsApp
            </ButtonFilled>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FeatureDisabledModal;